(function(){
    'use strict';
    
    // autoplay video functionality
    $( "[data-target^='#video-modal-']" ).click(function() { 
        var dataTarget = $(this).attr("data-target");
        var vidId = dataTarget; 

        var iframeEl = $(vidId+ " iframe"); 
        var vidSrc = $(vidId+ " iframe").attr('data_src');
        var vidSrcAuto = vidSrc+'?autoplay=1'; 
        $(vidId).on('show.bs.modal', function () {  
            $(iframeEl).attr("src", vidSrc);
        });
        $(vidId).on('hidden.bs.modal', function (e) {  
            $(iframeEl).attr("src", "");  
        });   
    }); 
}());
